// @ts-nocheck
import React from "react";
import NavContent from "./NavContent";

const SideMenu = ({ currentThread, threadDispatch, setShowMenu, showMenu }) => {
  return (
    <aside className={`sideMenu ${!showMenu ? "close" : ""}`}>
      <NavContent
        chatLog={currentThread?.messages || []}
        setChatLog={(newMessages) =>
          threadDispatch({
            type: "SET_THREAD_MESSAGES",
            payload: newMessages,
          })
        }
        setShowMenu={setShowMenu}
      />
    </aside>
  );
};

export default SideMenu;
